import { MyTasksWorkspace } from '../components/MyTasksWorkspace';
import type { PortalApplication, PortalIdentity } from '../../../model/portalModels';
import type { PortalTaskGroupKey } from '../model/myTasks';
import type { PreparedTaskSelection, TaskNavigate } from '../runtime/taskFormSelection';
import '../styles/my-tasks.css';
import { useMobilePortalLayout } from '../../../mobile/app/mobilePortalEntry';

export function MyTasksPage(props: {
  initialGroup?: PortalTaskGroupKey;
  initialTaskId?: string;
  applications: PortalApplication[];
  identity: PortalIdentity;
  preparedSelection?: PreparedTaskSelection;
  navigationLoadingMessage?: string;
  onNavigate: TaskNavigate;
  onSessionExpired: () => void;
}) {
  const mobile = useMobilePortalLayout();
  return <MyTasksWorkspace {...props} mobile={mobile} />;
}

